// The gw-pl-accordion-group directive indicates a block of html that will expand and collapse in an accordion

define([
        'text!edge/platform/widgets/accordion/directives/templates/accordion-group.html'
    ],
    (templateStr)=> {
        return [function () {
            return {
                require: '^gwPlAccordion',         // We need this directive to be inside an accordion
                restrict: 'EA',
                transclude: true,              // It transcludes the contents of the directive into the template
                replace: true,                // The element containing the directive will be replaced with the template
                template: templateStr,
                scope: {
                    gwPlHeading: '@',               // Interpolate the heading attribute onto this scope
                    isOpen: '=?',
                    initialIsOpen: '&',
                    isDisabled: '=?',
                    validationForm: '=',
                    flavour: '@'
                },
                controller() {
                    this.setHeading = (element)=> {
                        this.gwPlHeading = element;
                    };
                },
                link: (scope, element, attrs, accordionCtrl, transcludeFn)=> {
                    if (typeof scope.initialIsOpen() !== 'undefined') {
                        scope.isOpen = scope.initialIsOpen();
                    }

                    transcludeFn((clonedMarkup, childScope) => {
                        element.find('[transclude-here]').append(clonedMarkup);
                        childScope.isAccordionOpen = () => scope.isOpen;
                    });

                    scope.flavour = scope.flavour || 'default';
                    accordionCtrl.addGroup(scope);

                    scope.$watch('isOpen', (value)=> {
                        if (value) {
                            accordionCtrl.closeOthers(scope);
                        }
                    });

                    scope.toggleOpen = ()=> {
                        if (!scope.isDisabled) {
                            scope.isOpen = !scope.isOpen;
                        }
                    };
                }
            };
        }];
    });


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/widgets/accordion/directives/accordionGroup.js
 **/